import { Box, LoadingOverlay } from '@mantine/core'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireNoAuth } from '@/features/auth/lib'
import { useCheckAuthStatus } from '@/features/auth/oneTimeCode/api'
import { AuthLayout } from '@/features/auth/ui'

export const Route = createFileRoute('/_signin')({
  component: RouteComponent,
  beforeLoad: () => requireNoAuth(),
})

function RouteComponent() {
  const { isRedirecting } = useCheckAuthStatus()

  return (
    <Box style={{ position: 'relative', minHeight: '100vh' }}>
      <LoadingOverlay
        visible={isRedirecting}
        zIndex={1000}
        overlayProps={{ radius: 'sm', blur: 2 }}
      />
      <AuthLayout>
        <Outlet />
      </AuthLayout>
    </Box>
  )
}
